import React, { useEffect, useState } from 'react';
import {  Form, Row, Col, Card } from 'react-bootstrap';
import axios from 'axios';
import { showToast } from '_metronic/helpers';
import { SERVER_URL } from 'app/ServerConfig';
import { PageTitle } from '_metronic/layout/core';
import { checkPermission } from 'app/utils/checkPermission';

const QuantityProfitPage: React.FC = () => {
    const [profits, setProfits] = useState<{ [qty: number]: string }>({});
    useEffect(() => {
        const fetchProfits = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(
                    `${SERVER_URL}/product/group/list-quantity-profit`,
                    {
                        headers: {
                            Authorization: token ? `Bearer ${token}` : '',
                            Accept: 'application/json',
                        },
                    }
                );
                const apiQuantities = Array.isArray(response.data?.responseData) ? response.data.responseData : [];
                const profitMap: { [qty: number]: string } = {};
                for (let i = 1; i <= 100; i++) {
                    const found = apiQuantities.find((q: any) => String(q.quantity) === String(i));
                    profitMap[i] = found ? String(found.profit) : '0';
                }
                setProfits(profitMap);
            } catch (err) {
                const next: { [qty: number]: string } = {};
                for (let i = 1; i <= 100; i++) {
                    next[i] = '0';
                }
                setProfits(next);
            }
        };
        fetchProfits();
    }, []);


    const canUpdate = checkPermission('Quantity Wise Profit', 'update');

    const handleProfitChange = (qty: number, value: string) => {
        if (!canUpdate) return;
        if (
            (value === '' || /^[-+]?\d*(\.\d{0,3})?$/.test(value)) &&
            value.length <= 9
        ) {
            setProfits((prev) => ({ ...prev, [qty]: value }));
        }
    };

    const handleProfitBlur = async (qty: number) => {
        if (!canUpdate) return;
        const profit = profits[qty] ?? '0';
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                `${SERVER_URL}/product/group/add-or-update-quantity-profit`,
                {
                    quantity: String(qty),
                    profit,
                },
                {
                    headers: {
                        Authorization: token ? `Bearer ${token}` : '',
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }
            );
            if (response.data && response.data.responseMessage) {
                showToast({ message: response.data.responseMessage, autoClose: 1000 });
            }
        } catch (err) {
            // Optionally show error toast
        }
    };



    // Create two arrays for the two tables (1-50 and 51-100)
    const firstTableRows = Array.from({ length: 50 }, (_, i) => i + 1);
    const secondTableRows = Array.from({ length: 50 }, (_, i) => i + 51);
    <div className="d-flex justify-content-between align-items-center mb-4">
        <PageTitle>Quantity-Profit Table</PageTitle>

    </div>
    return (<>
        <div className="d-flex justify-content-between align-items-center mb-4">
            <PageTitle > Quantity Profit</PageTitle>
            <Col className='mb-10'></Col>


        </div>
        <div>
            <Row>
                <Col md={6}>
                    <Card className="shadow-sm mb-4">
                        <Card.Body className="p-0">
                            <div style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover table-sm text-center align-middle border mb-0">
                                    <thead className="table-light sticky-top">
                                        <tr>
                                            <th style={{ width: '40%' }}>Quantity</th>
                                            <th style={{ width: '60%' }}>Profit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {firstTableRows.map((qty) => (
                                            <tr key={qty}>
                                                <td className="fw-semibold">{qty}</td>
                                                <td>
                                                    <Form.Control
                                                        type="text"
                                                        value={profits[qty] ?? '0'}
                                                        onChange={(e) => handleProfitChange(qty, e.target.value)}
                                                        onBlur={() => handleProfitBlur(qty)}
                                                        placeholder="Profit"
                                                        size="sm"
                                                        style={{
                                                            maxWidth: 90,
                                                            minWidth: 60,
                                                            padding: '2px 6px',
                                                            fontSize: 13,
                                                            textAlign: 'right',
                                                            margin: '0 auto',
                                                            display: 'block',
                                                            borderRadius: 6,
                                                        }}
                                                        readOnly={!canUpdate}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="shadow-sm mb-4">
                        <Card.Body className="p-0">
                            <div style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover table-sm text-center align-middle border mb-0">
                                    <thead className="table-light sticky-top">
                                        <tr>
                                            <th style={{ width: '40%' }}>Quantity</th>
                                            <th style={{ width: '60%' }}>Profit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {secondTableRows.map((qty) => (
                                            <tr key={qty}>
                                                <td className="fw-semibold">{qty}</td>
                                                <td>
                                                    <Form.Control
                                                        type="text"
                                                        value={profits[qty] ?? '0'}
                                                        onChange={(e) => handleProfitChange(qty, e.target.value)}
                                                        onBlur={() => handleProfitBlur(qty)}
                                                        placeholder="Profit"
                                                        size="sm"
                                                        style={{
                                                            maxWidth: 90,
                                                            minWidth: 60,
                                                            padding: '2px 6px',
                                                            fontSize: 13,
                                                            textAlign: 'right',
                                                            margin: '0 auto',
                                                            display: 'block',
                                                            borderRadius: 6,
                                                        }}
                                                        readOnly={!canUpdate}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    </>
    );
};

export default QuantityProfitPage;